// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._3O1MHxEux{width:100%;height:100%;background-color:#f8f8f8}._6pGfTPCxx{justify-content:center;flex-direction:column;padding:10px}.nvpTQPfTx{max-width:100%}._6nnPj5mXx{display:block}._20EiUoblx{margin-bottom:10px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"profile-container": "_3O1MHxEux",
	"profileContainer": "_3O1MHxEux",
	"user-badge": "_6pGfTPCxx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"userBadge": "_6pGfTPCxx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"name": "nvpTQPfTx",
	"my-devices-title": "_6nnPj5mXx",
	"myDevicesTitle": "_6nnPj5mXx",
	"device-text": "_20EiUoblx",
	"deviceText": "_20EiUoblx"
};
module.exports = exports;
